import { useEffect, useState } from 'react';
import { BellOff } from 'lucide-react';
import ChefHeader from '../shared/ui/ChefHeader';
import { LoadingView, EmptyState } from '../shared/ui';
import { useAuth } from '../contexts/AuthContext';
import {
  listenToNotifications, markNotificationRead,
  markAllNotificationsRead, deleteNotification,
} from '../shared/services/notificationService';
import NotificationRow from '../components/alerts/NotificationRow';
import NotificationDetailSheet from '../components/alerts/NotificationDetailSheet';

// Mirrors iOS DriverNotificationView: live notification list, unread dot,
// tap → detail sheet + mark read, swipe actions → inline mark-read/delete
// buttons, red "Mark All as Read" footer.
export default function AlertsPage() {
  const { user } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (!user?.uid) return undefined;
    setLoading(true);
    return listenToNotifications(user.uid, list => {
      setNotifications(list);
      setLoading(false);
    });
  }, [user?.uid]);

  const openNotification = n => {
    setSelected(n);
    if (!n.isRead) markNotificationRead(n.id).catch(e => console.error('markRead', e));
  };

  const handleMarkRead = n =>
    markNotificationRead(n.id).catch(e => console.error('markRead', e));

  const handleDelete = n =>
    deleteNotification(n.id).catch(e => console.error('deleteNotification', e));

  const handleMarkAll = () =>
    markAllNotificationsRead(user.uid).catch(e => console.error('markAllRead', e));

  return (
    <div className="flex flex-col min-h-full">
      <ChefHeader title="Notifications" />

      {loading ? (
        <LoadingView label="Loading alerts…" />
      ) : notifications.length === 0 ? (
        <EmptyState
          icon={BellOff}
          title="No Driver Notifications"
          subtitle="Driver updates will appear here."
        />
      ) : (
        <>
          <div className="px-4 py-3 space-y-2 flex-1">
            {notifications.map(n => (
              <NotificationRow
                key={n.id}
                notification={n}
                onTap={() => openNotification(n)}
                onDelete={handleDelete}
                onMarkRead={handleMarkRead}
              />
            ))}
          </div>

          <div className="px-4 pb-4">
            <button
              onClick={handleMarkAll}
              className="w-full py-2 rounded-full bg-[#FF3B30] text-white text-sm font-semibold active:scale-[0.98] transition-transform"
            >
              Mark All as Read
            </button>
          </div>
        </>
      )}

      <NotificationDetailSheet
        notification={selected}
        onClose={() => setSelected(null)}
      />
    </div>
  );
}
